import { formatTenths } from '../decimal.ts';

/** Spanish coordinate-plane prompts (ADR 0085 §2, §5). Pairs are written as in English. */
export const coordinatePrompts = {
    slopeWord: 'pendiente',
    slopeFromPoints: (first: string, second: string) => `¿Cuál es la pendiente de la recta que pasa por ${first} y ${second}?`,
    readPoint: (label: string) => `¿Cuáles son las coordenadas del punto ${label}?`,
    namePoint: (pair: string) => `¿Qué punto está en ${pair}?`,
    distance: (from: string, to: string) => `¿A qué distancia está el punto ${from} del punto ${to}?`,
    quadrant: (label: string) => `¿En qué cuadrante está el punto ${label}?`,
    pair: (x: number, y: number) => `(${x}, ${y})`,
    units: (count: number) => `${count} ${count === 1 ? 'unidad' : 'unidades'}`,
    /** Polygons (ADR 0087 §3, §5). The name carries its preposition: "del rectángulo", "de la figura". */
    shapeName: (rectangle: boolean, corners: string) => `${rectangle ? 'del rectángulo' : 'de la figura'} ${corners}`,
    area: (shape: string) => `¿Cuál es el área ${shape}?`,
    perimeter: (shape: string) => `¿Cuál es el perímetro ${shape}?`,
    side: (side: string) => `¿Cuánto mide el lado ${side}?`,
    /** Triangles (ADR 0092 §4): la altura sobre la base. */
    triangleName: (corners: string) => `del triángulo ${corners}`,
    base: (base: string) => `¿Cuánto mide la base ${base}?`,
    height: (base: string) => `¿Cuál es la altura sobre la base ${base}?`,
    squareUnits: (count: number) => `${count} ${count === 1 ? 'unidad cuadrada' : 'unidades cuadradas'}`,
    /** Missing Corner (ADR 0094 §5). Each given corner is its letter and pair: "A (2, 3)". */
    missingCorner: (given: string[], missing: string) =>
        `El rectángulo ABCD tiene los vértices ${given.slice(0, -1).join(', ')} y ${given[given.length - 1]}. ¿Cuáles son las coordenadas de ${missing}?`,
    /** Distance Between Points (ADR 0125 §3). A decimal point, as in English (ADR 0106 §3). */
    pointDistance: (from: string, to: string) => `¿A qué distancia está el punto ${from} del punto ${to}, a la décima más cercana?`,
    pointDistanceWhole: (horizontal: number, vertical: number, sum: number, distance: number) =>
        `${horizontal}² + ${vertical}² = ${sum}: ${distance} unidades`,
    pointDistanceRounded: (horizontal: number, vertical: number, sum: number, tenths: number) =>
        `${horizontal}² + ${vertical}² = ${sum}: aprox. ${formatTenths(tenths, '.')} unidades`,
};
